'use strict';

import { listenDOMEvent } from '@jspartials/dom-api-utils';
import { addToList } from '@jspartials/general-utils';

// Selectors
const selector = {
  imagesCarousel: {
    wrapper: '.js-images-carousel',
    content: '.js-images-carousel__content',
    item: '.js-images-carousel__item',
    button: {
      prev: '.js-images-carousel__button-prev',
      next: '.js-images-carousel__button-next'
    }
  }
};

// Variables
const listOfImagesCarousel = [];

// Functions

/**
 * Listen images carousel elements
 * @returns {void}
 */
const listenImagesCarousel = () => {
  const imagesCarousel =
    document.querySelectorAll(selector.imagesCarousel.wrapper) || [];

  if (imagesCarousel.length > 0) {
    imagesCarousel.forEach((carousel) => {
      if (!listOfImagesCarousel.includes(carousel)) {
        addToList(carousel, listOfImagesCarousel);
        listenImagesCarouselNavigationButtons(carousel);
      }
    });
  }
};

/**
 * Listen images carousel navigation buttons
 * @param {HTMLElement} carousel - Carousel element
 * @returns {void}
 */
const listenImagesCarouselNavigationButtons = (carousel) => {
  const prevButton =
    carousel.querySelector(selector.imagesCarousel.button.prev) || null;
  const nextButton =
    carousel.querySelector(selector.imagesCarousel.button.next) || null;

  if (prevButton) {
    listenDOMEvent(prevButton, 'click', (event) => {
      event.preventDefault();
      event.stopPropagation();
      navigateTo(carousel, 'prev');
    });
  }

  if (nextButton) {
    listenDOMEvent(nextButton, 'click', (event) => {
      event.preventDefault();
      event.stopPropagation();
      navigateTo(carousel, 'next');
    });
  }
};

/**
 * Navigate to a specific index
 * @param {HTMLElement} carousel - Carousel element
 * @param {String} direction - Direction to navigate
 * @returns {void}
 */
const navigateTo = (carousel, direction) => {
  const currentIndex = getCurrentIndex(carousel);
  const totalItems = getTotalItems(carousel);
  const scrollTo =
    direction === 'prev'
      ? currentIndex > 0
        ? currentIndex - 1
        : 0
      : currentIndex < totalItems - 1
      ? currentIndex + 1
      : totalItems - 1;
  scrollToIndex(carousel, scrollTo);
};

/**
 * Scroll to a specific index
 * @param {HTMLElement} wrapper - Wrapper element
 * @param {Number} scrollTo - Index to scroll to
 * @returns {void}
 */
const scrollToIndex = (wrapper, scrollTo) => {
  const item = wrapper.querySelector(selector.imagesCarousel.item) || null;
  const itemWidth = item ? item.offsetWidth : 1;

  wrapper.scrollLeft = scrollTo * itemWidth;
};

/**
 * Get current index
 * @param {HTMLElement} wrapper - Wrapper element
 * @returns {Number} Current index
 */
const getCurrentIndex = (wrapper) => {
  const item = wrapper.querySelector(selector.imagesCarousel.item) || null;
  const itemWidth = item ? item.offsetWidth : 1;

  return Math.round(wrapper.scrollLeft / itemWidth);
};

/**
 * Get total items
 * @param {HTMLElement} wrapper - Wrapper element
 * @returns {Number} Total items
 */
const getTotalItems = (wrapper) => {
  const items = wrapper.querySelectorAll(selector.imagesCarousel.item) || [];

  return items.length;
};

// Export
export { listenImagesCarousel };
